import { UiPricingComparisonValueModel } from "../../models";

import { mockAdfDocument } from "./mock-adf-doc";

export function mockUiPricingComparisonValueModel({
    id = "pricing-comparison-value-1234",
    type = "uiPricingComparisonValue",
    locale = "en",
    content = mockUiPricingComparisonValueModelContent()
}: Partial<UiPricingComparisonValueModel> = {}): UiPricingComparisonValueModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiPricingComparisonValueModelContent =
    UiPricingComparisonValueModel["content"];

export function mockUiPricingComparisonValueModelContent({
    entryTitle = "Demo pricing comparison value",
    value = mockAdfDocument(),
    ...optionals
}: Partial<UiPricingComparisonValueModelContent> = {}): UiPricingComparisonValueModelContent {
    return {
        entryTitle,
        value,
        ...optionals
    };
}
